import React from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import { useLightMode } from "hooks/general-hooks";
import { ReactComponent as Sun } from "svg/light-mode/sun.svg";
import { ReactComponent as Moon } from "svg/light-mode/moon.svg";
import { ReactComponent as SunActive } from "svg/light-mode/sun-active.svg";
import { ReactComponent as MoonActive } from "svg/light-mode/moon-active.svg";
import { ReactComponent as SunInactive } from "svg/light-mode/sun-inactive.svg";
import { ReactComponent as MoonInactive } from "svg/light-mode/moon-inactive.svg";
import Icon from "./Icon";

const LightModeToggle = () => {
  const { lightMode, lightModeOn, setLightModeEnabled } = useLightMode();

  if (!lightMode.allowed) {
    return null;
  }

  return (
    <div className="light-mode-toggle">
      <TooltipContainer
        tooltipInfo={"Light Mode Beta (Profiles)"}
        // forceOrientation="right"
      >
        <div className="sun-container">
          <Icon
            selected={lightModeOn}
            onClick={() => setLightModeEnabled(true)}
            normalSVG={<Sun />}
            activeSVG={<SunActive />}
            inactiveSVG={<SunInactive />}
          />
          <div className="new-tag">
            <div className="new-tag-text">N</div>
          </div>
        </div>
      </TooltipContainer>
      <div className="divider" />
      <Icon
        selected={!lightModeOn}
        onClick={() => setLightModeEnabled(false)}
        normalSVG={<Moon />}
        activeSVG={<MoonActive />}
        inactiveSVG={<MoonInactive />}
      />
    </div>
  );
};

export default LightModeToggle;
